<template>
  <div>
    <div :key="item.iloId" class="mx-5" v-for="item in items">
      <v-checkbox
        :class="`mt-0 word-break-all ${isRightAlignment ? 'text-align-right' : 'text-align-left'}`"
        hide-details="auto"
        color="primary"
        @update:model-value="onChangeCheckBox({ isSelected: $event, item })"
        :disabled="item.unremovable"
        :model-value="isParentSelected(item)"
        :label="item.description"
        :key="item.iloId"
      />
      <RecursiveILOsCheckbox
        @ilo-checkbox-change="onChangeCheckBox"
        v-if="item.children && Object.values(item.children).length > 0"
        :items="Object.values(item.children)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { FlexibleILOsData } from '@/types/ilos.type';

export default defineComponent({
  name: 'RecursiveILOsCheckbox',
  props: {
    items: {
      type: Array as PropType<FlexibleILOsData[]>,
      required: true,
    },
  },
  computed: {
    isRightAlignment(): boolean {
      return this.$store.state.lang.lang === 'ar';
    },
    isParentSelected(): any {
      return (item: FlexibleILOsData) => {
        if (item.children && Object.values(item.children).length > 0) {
          return !Object.values(item.children)
            .map((subItem) => {
              if (subItem.children && Object.values(subItem.children).length > 0) {
                return this.isParentSelected(subItem);
              }
              return subItem.selected;
            })
            .includes(false);
        }
        return item.selected;
      };
    },
  },
  methods: {
    onChangeCheckBox(props: { isSelected: boolean; item: FlexibleILOsData }) {
      this.$emit('ilo-checkbox-change', { isSelected: props.isSelected, item: props.item });
    },
  },
});
</script>

<style scoped>
.word-break-all {
  word-break: break-all;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left;
}
</style>
